/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { FilePath } from '../models/FilePath';
import { ObjectStorageDestination } from '../models/ObjectStorageDestination';

export class RestoreFilesRequest {
  'destination': ObjectStorageDestination;
  /**
  * List of file paths to restore.
  */
  'files': Array<FilePath>;
  /**
  * Eon-assigned ID of the restore account.
  */
  'restoreAccountId': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "destination",
      "baseName": "destination",
      "type": "ObjectStorageDestination",
      "format": ""
    },
    {
      "name": "files",
      "baseName": "files",
      "type": "Array<FilePath>",
      "format": ""
    },
    {
      "name": "restoreAccountId",
      "baseName": "restoreAccountId",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RestoreFilesRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

